export const sentryConfig = {
  dsn: "https://2a252de469baee376666cf32e3c9f95a@o4507034771914752.ingest.us.sentry.io/4507469820329984",
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
}
